<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Vendor Payments</span>
            <div>

                <el-button class="ml-2 white-btn" size="small" @click="add()" v-if="enquiry.ispriceeditaccess">Add Payment</el-button>
            </div>
        </template>
        <el-row v-if="enquiry.vendorpayments.length>0">
            <el-col >
                <el-table size="small" :data="enquiry.vendorpayments" border style="width: 100%">
                    <el-table-column prop="department" label="#"  width="40" >
                        <template #default="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="type" label="Type"  />
                    <el-table-column prop="vendor.vendor_name" label="Vendor"  />
                    <el-table-column prop="paid_on" label="Paid On"  />
                    <el-table-column prop="amount" label="Amount"  >
                        <template #default="scope">
                            {{Intl.NumberFormat('en-US').format(scope.row.amount)}}
                        </template>

                    </el-table-column>
                    <el-table-column prop="payment_source" label="Source"  />
                    <el-table-column prop="paid_by" label="Paid By"  />
                    <el-table-column prop="payment_status" label="Status"  >
                        <template #default="scope">
                            <el-tag type="info" v-if="scope.row.payment_status=='Pending'">Pending</el-tag>
                            <el-tag type="warning" v-else-if="scope.row.payment_status=='Inprogress'">Inprogress</el-tag>
                            <el-tag type="success" v-else-if="scope.row.payment_status=='Paid'">Paid</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="attachment" label="Attachment"  >
                        <template #default="scope">
                            <el-link class="mr-2"  type="primary" v-if="scope.row.attachment!=null"  @click="viewfile(scope.row.attachment.link)" >View File</el-link>
                            <el-button   type="info" size="small" @click="addattachment(scope.row.id)">
                                <el-icon>
                                    <Link />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="invoice" label="Invoice"  >
                        <template #default="scope">
                            <el-link class="mr-2"  type="primary" v-if="scope.row.invoice!=null"  @click="viewfile(scope.row.invoice.link)" >View File</el-link>
                            <el-button   type="info" size="small" @click="addinvoice(scope.row.id)">
                                <el-icon>
                                    <Link />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="department" label="Action"  fixed="right" width="100">
                        <template #default="scope">
                            <el-button v-if="enquiry.permissions.vendorpayments.edit" type="primary" size="small" @click="editpayment(scope.row)">
                                <el-icon>
                                 <Edit />
                                </el-icon>
                            </el-button>
                            <el-button v-if="enquiry.permissions.vendorpayments.edit"  type="danger" size="small" @click="deletepayment(scope.row)">
                                <el-icon>
                                    <Delete />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

    </el-card>

    <el-dialog
        v-model="dialogDelete"
        title="Delete Payment?"
        width="500"
    >
        <p>Type : {{ deletePayment.type }}</p>
        <p>Vendor : {{ deletePayment.vendor.vendor_name }}</p>
        <p>Paid On : {{ deletePayment.paid_on }}</p>
        <p>Amount :  {{Intl.NumberFormat('en-US').format(deletePayment.amount)}}</p>
        <p>Source : {{ deletePayment.payment_source }}</p>
        <p>Paid By : {{ deletePayment.paid_by }}</p>
        <p>Status : {{ deletePayment.payment_status }}</p>

        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" :disabled="deleting" @click="dialogDelete = false">Cancel</el-button>
                <el-button type="primary" :disabled="deleting" :loading="deleting" @click="deletepaymentsubmit()">
                    Confirm
                </el-button>
            </div>
        </template>
    </el-dialog>

    <el-drawer  v-model="dialogAdd" direction="rtl">
        <template #header>
            <h4>Vendor Payment</h4>
        </template>
        <template #default>
            <el-form
                ref="paymentruleFormRef"
                :model="paymentform"
                status-icon
                :rules="paymentrules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >


                <el-form-item label="Vendor" prop="vendor" >
                    <Select2 :options="paymentform.selvendor" style="width:100%"  v-model="paymentform.vendor"   :settings="vendorsajax" required/>

                </el-form-item>

                <el-form-item label="Type" prop="type" >
                    <el-select style="width:100%"   v-model="paymentform.type" >
                        <el-option label="Hotel"  value="Hotel"></el-option>
                        <el-option label="Flight"  value="Flight"></el-option>
                        <el-option label="Visa"  value="Visa"></el-option>
                        <el-option label="Land"  value="Land"></el-option>
                        <el-option label="Insurance"  value="Insurance"></el-option>
                        <el-option label="Cruise"  value="Cruise"></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="Amount" prop="amount" >
                    <el-input type="number"   v-model="paymentform.amount" />

                </el-form-item>
                <el-form-item label="Payment Status" prop="payment_status" >
                    <el-select style="width:100%"   v-model="paymentform.payment_status" >
                        <el-option label="Pending"  value="Pending"></el-option>
                        <el-option label="Inprogress"  value="Inprogress"></el-option>
                        <el-option label="Paid"  value="Paid" ></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="Payment Source" prop="payment_source" >
                    <el-select style="width:100%"   v-model="paymentform.payment_source" >
                        <el-option label="Online"  value="Online"></el-option>
                        <el-option label="Cash"  value="Cash"></el-option>
                        <el-option label="Cheque"  value="Cheque"></el-option>
                     </el-select>

                </el-form-item>
                <el-form-item label="Paid By" prop="paid_by" >
                    <el-input    v-model="paymentform.paid_by" />

                </el-form-item>

                <el-form-item label="Paid On" prop="paid_on" >
                    <el-date-picker  type="date" style="width:100%"   v-model="paymentform.paid_on" format="DD-MM-YYYY" value-format="YYYY-MM-DD" />

                </el-form-item>


            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogAdd=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Submit</el-button>
            </div>
        </template>
    </el-drawer>
    <el-drawer  v-model="dialogAttachment" direction="rtl">
        <template #header>
            <h4>Payment Attachment</h4>
        </template>
        <template #default>
            <el-form
                ref="attachmentruleFormRef"
                :model="attachmentform"
                status-icon
                :rules="attachmentrules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >

                <el-form-item label="File" prop="file">
                    <input type="file"  @change="attachmentform.file=$refs.documentfile.files[0]"     ref="documentfile"   placeholder="Source" />

                </el-form-item>



            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogAttachment=false">Cancel</el-button>
                <el-button type="primary" @click="submitPAForm()" :loading="uploading" :disabled="uploading">Upload</el-button>
            </div>
        </template>
    </el-drawer>
    <el-drawer  v-model="dialogInvoice" direction="rtl">
        <template #header>
            <h4>Payment Invoice</h4>
        </template>
        <template #default>
            <el-form
                ref="invoiceruleFormRef"
                :model="invoiceform"
                status-icon
                :rules="invoicerules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >

                <el-form-item label="File" prop="file">
                    <input type="file"  @change="invoiceform.file=$refs.documentfile.files[0]"     ref="documentfile"   placeholder="Source" />

                </el-form-item>



            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogInvoice=false">Cancel</el-button>
                <el-button type="primary" @click="submitPIForm()" :loading="uploading2" :disabled="uploading2">Upload</el-button>
            </div>
        </template>
    </el-drawer>

</template>

<script>
import {
    ElDatePicker,ElSelect,ElOption,ElLink,ElTag,ElIcon,ElTable,ElTableColumn,ElRow,ElCol,ElCard,ElDropdownItem,ElDropdownMenu,ElDropdown,ElDialog,ElButton,ElDrawer,ElForm,ElFormItem,ElInput
} from 'element-plus'
import $ from "jquery";
import { Link,Edit,Delete } from '@element-plus/icons-vue'
import moment from "moment";
export default {
    name: "VendorPayments",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        },
        authuser: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: {  ElDatePicker,ElSelect,ElOption,Link,ElLink,ElTag,Delete,ElIcon,Edit,ElTable,ElTableColumn,ElRow,ElCol,ElCard,ElDropdownItem,ElDropdownMenu,ElDropdown,ElDialog,ElButton,ElForm,ElDrawer,ElFormItem,ElInput },
    data() {
        return {
            dialogAttachment:false,
            dialogInvoice:false,
            uploading:false,
            uploading2:false,
            dialogAdd:false,
            loading:false,
            deletePayment:null,
            deleting:false,
            dialogDelete:false,
            vendorsajax: {
                ajax: {
                    url: '/vendor/ajaxlist',
                    dataType: 'json',
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    id: item.id
                                }
                            })
                        };
                    },
                    cache: true
                }
            },
            paymentform:{
                type:'',
                selvendor:[],
                vendor:null,
                payment_id:'',
                amount:'',
                payment_status:'',
                payment_source	:'',
                paid_by:'',
                paid_on:'',
            },
            paymentrules:{
                type:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                amount:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                vendor:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                payment_status:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                payment_source:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                paid_by:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                paid_on:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
            },
            attachmentform:{
                payment_id:'',
                file:''
            },
            attachmentrules:{
                file:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
            },
            invoiceform:{
                payment_id:'',
                file:''
            },
            invoicerules:{
                file:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
            },

        }
    },
    created(){

    },
    methods:{
        add(){
            this.dialogAdd=true;
            this.paymentform.type='';
            this.paymentform.selvendor=[];
            this.paymentform.vendor='';
            this.paymentform.payment_id='';
            this.paymentform.amount='';
            this.paymentform.payment_status='';
            this.paymentform.payment_source='';
            this.paymentform.paid_by='';
            this.paymentform.paid_on='';

        },

        viewfile(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        },
        deletefile(attach){
                this.dialogDelete=true;
                this.deleteattach=attach;

        },
        submitForm(){
            const formEl=this.$refs.paymentruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.submitpayment()
                } else {
                    return false
                }
            })


        },
        submitpayment(){
            let currentObj = this;
            currentObj.loading=true;
            axios.post('/enquiry/addvendorpayment?id='+this.enquiry.id,this.paymentform).then(function (response) {
                toastr.success('Payment Saved Succesfully.');
                currentObj.$emit("saved");
                currentObj.paymentform.type='';
                currentObj.paymentform.selvendor=[];
                currentObj.paymentform.vendor='';
                currentObj.paymentform.payment_id='';
                currentObj.paymentform.amount='';
                currentObj.paymentform.payment_status='';
                currentObj.paymentform.payment_source='';
                currentObj.paymentform.paid_by='';
                currentObj.paymentform.paid_on='';
                currentObj.loading=false;
                currentObj.dialogAdd=false;
            })
                .catch(function (error) {
                    if(error.response.status=="404"){
                        toastr.error(error.response.data);
                    }
                    else{
                        toastr.error('Something Wrong try again.');
                    }
                    currentObj.loading=false;
                });
        },
        addattachment(id){
            this.attachmentform.payment_id=id;
            this.attachmentform.file=null;
            this.dialogAttachment=true;
        },
        submitPAForm(){
            const formEl=this.$refs.attachmentruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.uploaddocument()
                } else {
                    return false
                }
            })
        },
        uploaddocument(){
            const headers = { 'Content-Type': "multipart/form-data" };
            const formData = new FormData();
            formData.append('file',this.attachmentform.file);
            formData.append('payment_id',this.attachmentform.payment_id);

            let currentObj = this;
            axios.post('/enquiry/addvendorpaymentattachment?id='+this.enquiry.id,formData).then(function (response) {
                toastr.success('Attachment Saved Succesfully.');
                currentObj.$emit("saved");
                currentObj.uploading=false;
                currentObj.dialogAttachment=false;
            })
                .catch(function (error) {
                    if(error.response.status=="404"){
                        toastr.error(error.response.data);
                    }
                    else{
                        toastr.error('Something Wrong try again.');
                    }
                    currentObj.uploading=false;
                });


        },
        addinvoice(id){
            this.invoiceform.payment_id=id;
            this.invoiceform.file=null;
            this.dialogInvoice=true;
        },
        submitPIForm(){
            const formEl=this.$refs.invoiceruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.uploadinvoice()
                } else {
                    return false
                }
            })
        },
        uploadinvoice(){
            const headers = { 'Content-Type': "multipart/form-data" };
            const formData = new FormData();
            formData.append('file',this.invoiceform.file);
            formData.append('payment_id',this.invoiceform.payment_id);

            let currentObj = this;
            axios.post('/enquiry/addvendorinvoiceattachment?id='+this.enquiry.id,formData).then(function (response) {
                toastr.success('Attachment Saved Succesfully.');
                currentObj.$emit("saved");
                currentObj.uploading2=false;
                currentObj.dialogInvoice=false;
            })
                .catch(function (error) {
                    if(error.response.status=="404"){
                        toastr.error(error.response.data);
                    }
                    else{
                        toastr.error('Something Wrong try again.');
                    }
                    currentObj.uploading2=false;
                });


        },
        editpayment(temppayment){
            this.paymentform.paid_on=moment(temppayment.paid_on, "DD-MM-YYYY").format('YYYY-MM-DD');
            this.paymentform.paid_by=temppayment.paid_by;
            this.paymentform.amount=temppayment.amount;
            this.paymentform.payment_source=temppayment.payment_source;
            this.paymentform.payment_status=temppayment.payment_status;
            this.paymentform.payment_id=temppayment.id;
            this.paymentform.type=temppayment.type;
            this.paymentform.selvendor=[{id: temppayment.vendor.id, text: temppayment.vendor.vendor_name}];
            this.paymentform.vendor=temppayment.vendor.id;
            this.dialogAdd=true;


        },
        deletepayment(payment){
            this.deletePayment=payment;
            this.dialogDelete=true;
        },
        deletepaymentsubmit(){
            let currentObj = this;
            currentObj.deleting=true;
            axios.post('/enquiry/deletevendorpayment', {'id':this.deletePayment.id}).then(function (response) {

                toastr.success('Payment Deleted Succesfully.');
                currentObj.$emit("saved");
                currentObj.deleting=false;
                currentObj.dialogDelete=false;
            })
                .catch(function (error) {
                    toastr.error('Something Wrong try again.');
                    currentObj.deleting=false;
                });
        },



    }
}
</script>

<style scoped>

</style>
